import { render, staticRenderFns } from "./TableAgentePosVenda.vue?vue&type=template&id=a53a29c6&scoped=true&"
import script from "./TableAgentePosVenda.vue?vue&type=script&lang=js&"
export * from "./TableAgentePosVenda.vue?vue&type=script&lang=js&"
import style0 from "./TableAgentePosVenda.vue?vue&type=style&index=0&id=a53a29c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a53a29c6",
  null
  
)

export default component.exports